export const modifyMapViolatersData = (modifyMapViolatersData) => {
    const { threePData, productDetails=[] } = modifyMapViolatersData;
    const mapViolaterObj = {}
    productDetails.forEach((ele, index) => {
        mapViolaterObj[ele?.asin] = ele?.mapPrice
    })
    return threePData.map(ele => {
        return {
            asin: ele?.asin,
            sellerId: ele?.sellerId,
            offerPrice: ele?.offerPrice,
            mapPrice: mapViolaterObj[ele?.asin],
            sku: productDetails.find((elem) => elem?.asin === ele?.asin)?.sku || '',
            violated: Number(ele?.offerPrice) > Number(mapViolaterObj[ele?.asin])
        }
    })

}